import {getColorVariant} from '../buttons/utils'
import {Color, Paddings} from './types'

export const getIconSize = (
  leftIcon: boolean,
  rightIcon: boolean,
  paddings?: Paddings
): string => {
  if (paddings === 'none') {
    if (leftIcon && rightIcon) {
      return 'px-24'
    }
    if (leftIcon) {
      return 'pl-24 pr-0'
    }
    if (rightIcon) {
      return 'pr-24 pl-0'
    }
    return 'px-0'
  }

  // medium paddings
  if (leftIcon && rightIcon) {
    return 'px-36'
  }
  if (leftIcon) {
    return 'pl-36 pr-12'
  }
  if (rightIcon) {
    return 'pr-36 pl-12'
  }
  return 'px-12'
}

export const getDefaultTextColor = (color: Color): string => {
  const primary = 'text-primary'
  const secondary = 'text-secondary'
  const error = 'text-error'
  const warning = 'text-warning'
  const grey = 'text-secondary'
  const invert = 'text-invert'

  return getColorVariant(color, {
    primary,
    secondary,
    error,
    warning,
    grey,
    invert
  })
}
